/** Shared layout for /ad/sliding-logo and docs/scripts/generate-ad-sliding-logo-board.js */

export const BOARD_SIZE_PX = 512;
export const GRID_SIZE = 2;
export const SUBGRID = 2;
export const MACRO_GAP_PX = 3;
export const SUB_GAP_PX = 1;

export const NESTED_TOP_LEFT_COLORS = ["#ef4444", "#f97316", "#eab308", "#22c55e"];
export const NESTED_BOTTOM_RIGHT_COLORS = ["#2563eb", "#4f46e5", "#7c3aed", "#94a3b8"];
export const BLACK_COLOR = "#000000";
export const BLACK_SPLIT_COLORS = [BLACK_COLOR, BLACK_COLOR, BLACK_COLOR, BLACK_COLOR];

export const cellIndex = (row, col) => (row - 1) * GRID_SIZE + (col - 1);

export const NESTED_TOP_LEFT = cellIndex(1, 1);
export const NESTED_BOTTOM_RIGHT = cellIndex(2, 2);
export const BLACK_SPLIT_CELLS = [cellIndex(1, 2), cellIndex(2, 1)];
